import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  customScroll: {
    overflow: 'scroll',
    '::-webkit-scrollbar': {
      width: 0,
    },
    '::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.neutralLight,
      borderRadius: '6px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      backgroundColor: theme.palette.neutralLighter,
    },
  },
}));
